import { render } from "./EditInvoice.vue?vue&type=template&id=01379b9a"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"

import "./EditInvoice.vue?vue&type=style&index=0&id=01379b9a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__